import React from 'react';
import type { IconProps } from '../types';

export const OHIFLogo = (props: IconProps) => (
  <img src="https://obz.ai/logo/obzai-logo-dark.png" className="h-8 px-2 py-1" alt="OBZ.ai Logo" />
);

export default OHIFLogo;
